import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/Prenota';
import Menu from './pages/Menu';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Calendario from './pages/Calendario';
import Prenota from './pages/Prenota';
import CancelBooking from './pages/CancelBooking';

const App = () => {
    return (
        <Router>
            <div>
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path="/about" component={Prenota} />
                    <Route path="/menu" component={Menu} />
                    <Route path="/contact" component={Contact} />
                    <Route path="/admin" component={Admin} />
                    <Route path="/calendario" component={Calendario} />
                    <Route path="/cancel-booking/:code?" component={CancelBooking} />
                </Switch>
            </div>
        </Router>
    );
};

export default App;